import MainApp from './layout/MainApp';
import MainLayout from "./layout/MainLayout";
import FixedBottom from "./layout/FixedBottom";
import ApiService from "./utils/ApiService";
import LocationDialog from "./components/LocationDialog";
import FeaturedImage from "./components/FeaturedImage";
import router, {resetRouter, addRoutes} from "./router";
import WangEditor from "../lib/WangEditor.vue";
import MediaDialog from "./components/MediaDialog.vue";
import Login from "./auth/Login.vue";
import AuthService from "./utils/AuthService";

Vue.component('location-dialog', LocationDialog);
Vue.component('main-layout', MainLayout);
Vue.component('fixed-bottom', FixedBottom);
Vue.component('featured-image', FeaturedImage);
Vue.component('wang-editor', WangEditor);
Vue.component('media-dialog', MediaDialog);
Vue.prototype.$api = ApiService;

const routeContext = require.context('./', true, /routes\.js$/);
routeContext.keys().forEach(key => {
    const routes = routeContext(key);
    addRoutes(routes, 'administrator');
});

router.beforeEach((to, from, next) => {
    let {title} = to.meta;
    if (title) {
        document.title = title;
    }
    next();
});

const store = require('./store');
const i18n = new VueI18n(languages);
// The interface is English-only, whatever language a user's profile once chose.
i18n.locale = 'en';
new Vue({
    i18n,
    router,
    store,
    render(h) {
        const hasToken = AuthService.getToken();
        if (hasToken) {
            return h(MainApp);
        }
        return h(Login);
    }
}).$mount('#app');